import React, { FC } from 'react';
import { IconProps } from '.';

export const AttachmentIcon: FC<IconProps> = ({ size = 24, ...props }) => {
    const sizing = { width: size, height: size };

    return (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...sizing} {...props}>
            <path
                tabIndex={-1}
                d="M12 3.73926C14.8599 3.73926 16.7939 5.66739 16.9986 8.29168C17.0173 8.53107 16.8384 8.74028 16.599 8.75895C16.3596 8.77763 16.1504 8.5987 16.1317 8.3593C15.9613 6.17418 14.3911 4.60882 12 4.60882C9.6523 4.60882 8.09605 6.11777 7.88017 8.20873L7.86956 8.32549L7.86884 16.7437C7.9483 18.1268 9.10632 19.3914 10.4782 19.3914C11.8183 19.3914 12.9542 18.1849 13.0797 16.8632L13.0869 16.7686V9.19505C13.0869 8.5468 12.6316 8.08706 12 8.08706C11.3684 8.08706 10.913 8.5468 10.913 9.19505C10.913 9.43517 10.7184 9.62983 10.4782 9.62983C10.2381 9.62983 10.0435 9.43517 10.0435 9.19505C10.0435 8.06842 10.8862 7.2175 12 7.2175C13.0819 7.2175 13.9081 8.02049 13.9544 9.09917L13.9565 9.19505L13.9558 16.7936C13.8513 18.6116 12.341 20.2609 10.4782 20.2609C8.65135 20.2609 7.16338 18.6744 7.00762 16.8747L7 16.7686L7.00132 8.29168C7.20601 5.66739 9.14004 3.73926 12 3.73926Z"
                fill="#223944"
            />
            <path
                tabIndex={-1}
                d="M10.4777 8.95654C10.7007 8.95654 10.8845 9.12439 10.9096 9.34062L10.9125 9.39132V16.7826C10.9125 17.0227 10.7179 17.2174 10.4777 17.2174C10.2548 17.2174 10.071 17.0495 10.0459 16.8333L10.043 16.7826V9.39132C10.043 9.1512 10.2376 8.95654 10.4777 8.95654Z"
                fill="url(#paint0_linear_159_4694)"
            />
            <path
                tabIndex={-1}
                d="M16.5656 8.08716C16.7886 8.08716 16.9724 8.255 16.9975 8.47123L17.0004 8.52194V16.7828C17.0004 17.0229 16.8058 17.2175 16.5656 17.2175C16.3427 17.2175 16.1589 17.0497 16.1338 16.8335L16.1309 16.7828V8.52194C16.1309 8.28182 16.3255 8.08716 16.5656 8.08716Z"
                fill="url(#paint1_linear_159_4694)"
            />

            <defs>
                <linearGradient
                    id="paint0_linear_159_4694"
                    x1="9.71476"
                    y1="10.9813"
                    x2="9.71476"
                    y2="17.2174"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#223944" />
                    <stop offset="1" stopColor="#223944" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_159_4694"
                    x1="15.8026"
                    y1="10.3251"
                    x2="15.8026"
                    y2="17.2175"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#223944" />
                    <stop offset="1" stopColor="#223944" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
};
